// import React, { useEffect } from 'react';
// import { useParams } from 'react-router-dom';
// import config from '../config';

// const server_URL = config.SERVER_URL;

// const TrackingPixel = () => {
//   const { uid } = useParams();

//   useEffect(() => {
//     // Send tracking data
//     const track = async () => {
//       try {
//         await fetch(`${server_URL}/api/tracker`, {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ uid }),
//         });
//       } catch (error) {
//         console.error('Tracking error:', error);
//       }
//     };
//     track();
//   }, [uid]);

//   // This component doesn't render anything visible
//   return null;
// };

// // This is the key part - we need to handle this as an image request
// export const generateTrackingPixel = (req, res) => {
//   const { uid } = req.params;
  
//   // Log the tracking event
//   // Your tracking logic here
  
//   // Create a 1x1 transparent GIF
//   const pixel = Buffer.from('R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7', 'base64');
  
//   res.writeHead(200, {
//     'Content-Type': 'image/gif',
//     'Content-Length': pixel.length,
//     'Cache-Control': 'no-cache, no-store, must-revalidate',
//     'Pragma': 'no-cache',
//     'Expires': '0'
//   });
  
//   res.end(pixel);
// };

// export default TrackingPixel;


import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import config from '../config';

const server_URL = config.SERVER_URL;

const TrackingPixel = () => {
  const { uid } = useParams();

  useEffect(() => {
    const trackEmailOpen = async () => {
      try {
        console.log('Tracking email open for UID:', uid);
        
        const response = await fetch(`${server_URL}/api/tracker`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ 
            uid: uid,
            type: 'email_open',
            timestamp: new Date().toISOString()
          }),
        });

        if (response.ok) {
          const data = await response.json();
          console.log('Email open tracked successfully:', data);
        } else {
          console.error('Failed to track email open');
        }
      } catch (error) {
        console.error('Tracking error:', error);
      }
    };

    trackEmailOpen();
  }, [uid]);

  // This component doesn't render anything to the screen
  return null;
};

// Server-side function to handle direct image requests
export const trackingPixelLoader = async ({ params }) => {
  const { uid } = params;
  
  // Track the email open
  try {
    await fetch(`${server_URL}/api/tracker`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        uid: uid,
        type: 'email_open',
        timestamp: new Date().toISOString()
      }),
    });
  } catch (error) {
    console.error('Server-side tracking error:', error);
  }
  
  // Return 1x1 transparent GIF
  const transparentGif = Buffer.from('R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7', 'base64');
  
  return new Response(transparentGif, {
    status: 200,
    headers: {
      'Content-Type': 'image/gif',
      'Content-Length': transparentGif.length.toString(),
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0',
      'Access-Control-Allow-Origin': '*'
    },
  });
};

export default TrackingPixel;